var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},_vm._l((3),function(n){return _c('div',{key:n,staticClass:"spinner-grow",class:{
        'text-dark': !_vm.isValid(_vm.light),
        'text-light': _vm.isValid(_vm.light),
        'spinner-grow-small' : _vm.isValid(_vm.small)
      },attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }